import { AdsDetailApi } from '../../api'
import { setAdsReportTypes } from '../setAdsReportTypes'

export const fetchAdsReportTypes = () => async dispatch => {
  const api = new AdsDetailApi()
  const reportTypes = await api.getAdsReportTypes()
  dispatch(setAdsReportTypes(reportTypes))
}
